import axios from "axios";
import React, {useEffect, useState, useRef, Fragment} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import {render} from "react-dom";
import clientconfigwebapp, {
    empty_bk, convert_to_english_strhk, scrollTo_uphk, check_login_appbk, Token_get_appbk, redirectbh_typeb,
} from '../../../clientconfigwebapp';
import {ToastContainer, toast} from 'react-toastify';

import Master_Front_Buyer from "../../Master_Front_Buyer";


import "../../../components/assets/css/profile.css"
import "../../../assets/cssnew/panel.css"

import ReactFullPageLoadinghk from "../../../components/layaout/LoadingFullpagehk";


import Authentication_Documents_Tab1 from "../Authentication_Documents/Parts/Authentication_Documents_Tab1";
import Authentication_Documents_Tab2 from "../Authentication_Documents/Parts/Authentication_Documents_Tab2";


import Grid from '@mui/material/Grid';


import {Back, Iconbk_edit1, Information} from '../../../assets/icones/icones';


const Authentication_Documents = () => {
    const location = useLocation()
    const {tab_show_by_url} = useParams();


    const location_get_urlbk = useLocation();
    const redirect_navigate = useNavigate();
    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile, setData_first_name_profile] = useState('');
    const [last_name_profile, setData_last_name_profile] = useState('');
    const [profile_src, setData_profile_src] = useState('');
    const [type_user_panel, setData_type_user_panel] = useState('');
    /*  end profile */
    const [active_tab_curent, set_active_tab_curent] = useState("tab1")

    const [Data_Full_Get, set_Data_Full_Get] = useState([]);





    useEffect(() => {
        scrollTo_uphk();
        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
            return false;
        }


        Load_api_page();

    }, [location_get_urlbk]);

    const Load_api_page = () => {
        scrollTo_uphk();
        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
        }

        const config = {
            headers: {Authorization: `Bearer ${Token_get_appbk()}`}
        };

        Setloadinghkfullshow("true");

        const params = new URLSearchParams();
        params.append('page', "edit_profile");


        axios.post(`${clientconfigwebapp.siteurl}api/v1/dashboard-get`, params, config)
            .then((res) => {
                Setloadinghkfullshow("false");
                console.log(res.data);
                if (String(res.data).length > 0) {

                    if (String(res.data.data) == "login-show") {
                        redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
                    }

                    if (!empty_bk(res.data.type_user)) {
                        setData_type_user_panel(res.data.type_user);
                    }

                    set_Data_Full_Get(res.data);

                    if (String(res.data.wallet_inventory).length > 0) {
                        setData_wallet_balance(res.data.wallet_inventory);
                    }

                    if (!empty_bk(res.data.first_name_profile)) {
                        setData_first_name_profile(res.data.first_name_profile);
                        localStorage.setItem('first_name_Get', res.data.first_name_profile);
                    }
                    if (!empty_bk(res.data.last_name_profile)) {
                        setData_last_name_profile(res.data.last_name_profile);
                        localStorage.setItem('last_name_Get', res.data.last_name_profile);
                    }


                    if (!empty_bk(res.data.profile_src)) {
                        setData_profile_src(res.data.profile_src);
                    }


                } else {
                    if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

            }).catch((err) => {
            Setloadinghkfullshow("false");
            toast.error('خطا اتصال به سرور کد  435346', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        });


    }




    return (<Fragment>


<style jsx>{`

    .upload_box_documnet_aut {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px;
        gap: 10px;
        width: 100%;
        height: 22vh;
        background: #EDFAFA;
        border: 1px dashed #01A3D4;
        border-radius: 16px;
        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
        margin-bottom: 19px;
        cursor: pointer;
    }

    .help_box_image_sidebar {
        background-color: #f3F4F6;
        padding: 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 12px;
    }
  
`}</style>


            <Master_Front_Buyer type_user_panel={type_user_panel} wallet_balance={wallet_balance}
                                first_name_profile={first_name_profile} last_name_profile={last_name_profile}
                                profile_src={profile_src}>
                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}/>
                <ToastContainer/>

                <div className={"box-content-panelbk"}>

                    <span className={"title-box-content-panel"}>احراز هویت</span>

                    <div className={"container-bk"}>

                        <form id={"form_data_profile"} name={"form_data_profile"} encType="multipart/form-data"
                              style={{width: "100%"}}>


                            <div style={{
                                width: "100%",
                                "flexDirection": "column",
                                display: String(active_tab_curent) === 'tab1' ? 'flex' : 'none'
                            }}>


                                <Grid container direction="row" spacing={4} style={{paddingTop: "14px"}}>


                                    <Grid item lg={7} md={7} sm={12} xs={12}>


                                        <Authentication_Documents_Tab1 setActiveTabCurrent={set_active_tab_curent}
                                                                       Data_Full_Get={Data_Full_Get}/>


                                    </Grid>


                                    <Grid item lg={5} md={5} sm={12} xs={12}>

                                        <div className={"help_box_image_sidebar"}>

                                            <span>راهنما</span>


                                            <img src={String(clientconfigwebapp.webappurl) + "images/aut1.png"}/>


                                        </div>


                                    </Grid>


                                </Grid>


                            </div>


                            <div style={{
                                width: "100%",
                                "flexDirection": "column",
                                display: String(active_tab_curent) === 'tab2' ? 'flex' : 'none'
                            }}>


                                <Grid container direction="row" spacing={4} style={{paddingTop: "14px"}}>


                                    <Grid item lg={7} md={7} sm={12} xs={12}>


                                        <Authentication_Documents_Tab2 setActiveTabCurrent={set_active_tab_curent}
                                                                       Data_Full_Get={Data_Full_Get}/>


                                    </Grid>


                                    <Grid item lg={5} md={5} sm={12} xs={12}>

                                        <div className={"help_box_image_sidebar"}>

                                            <span>راهنما</span>


                                            <img src={String(clientconfigwebapp.webappurl) + "images/aut2.png"}/>


                                        </div>


                                    </Grid>


                                </Grid>


                            </div>


                            <div style={{
                                width: "100%",
                                "flexDirection": "column",
                                "paddingTop": "28px",
                                "paddingBottom": "25px",
                                display: String(active_tab_curent) === 'tab3' ? 'flex' : 'none'
                            }}>


                                <div style={{
                                    "width": "100%",
                                    "flexDirection": "column",
                                    "paddingTop": "28px",
                                    "paddingBottom": "13px",
                                    "display": "flex",
                                    "justifyContent": "center",
                                    "alignItems": "center"
                                }}>
                                    <svg width={63} height={63} viewBox="0 0 63 63" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_0_4438)">
                                            <path
                                                d="M31.5 5.66669C17.24 5.66669 5.66663 17.24 5.66663 31.5C5.66663 45.76 17.24 57.3334 31.5 57.3334C45.76 57.3334 57.3333 45.76 57.3333 31.5C57.3333 17.24 45.76 5.66669 31.5 5.66669ZM26.3333 44.4167L13.4166 31.5L17.0591 27.8575L26.3333 37.1059L45.9408 17.4984L49.5833 21.1667L26.3333 44.4167Z"
                                                fill="#0E9F6E"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_0_4438">
                                                <rect width={62} height={62} fill="white"
                                                      transform="translate(0.5 0.5)"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <span style={{
                                        fontSize: '22px',
                                        fontWeight: 'bold',
                                        marginBottom: '30px',
                                        marginTop: '30px'
                                    }}>موفق</span>
                                    <span style={{
                                        fontSize: '15px',
                                        color: '#4B5563',
                                        fontFamily: '"iran"',
                                        display: 'block',
                                        textAlign: 'center',
                                        "lineHeight": "1.6"
                                    }}>
                             اطلاعات شما با موفقیت برای کارشناسان بازارانو ارسال شد،
<br/>
                                        پس از بررسی و تایید کارشناسان، حساب شما احراز هویت خواهد شد.
                                    </span>


                                </div>


                            </div>


                        </form>

                    </div>

                </div>


            </Master_Front_Buyer>
        </Fragment>
    );
}


export default Authentication_Documents;